"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var Menu = _interopRequireWildcard(require("./MenuStyles"));
var _Icon = _interopRequireDefault(require("../../Icons/Icon"));
var _Search = _interopRequireDefault(require("../../Inputs/Search"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var propTypes = {
  /** Wether the menu is open or closed */
  isMenuOpen: _propTypes["default"].bool,
  /** Function to open the menu */
  openMenu: _propTypes["default"].func,
  /** Action on search */
  onSearch: _propTypes["default"].func
};
var MenuSearch = function MenuSearch(_ref) {
  var isMenuOpen = _ref.isMenuOpen,
    openMenu = _ref.openMenu,
    onSearch = _ref.onSearch;
  return /*#__PURE__*/_react["default"].createElement(Menu.SearchWrapper, {
    isMenuOpen: isMenuOpen
  }, isMenuOpen ? /*#__PURE__*/_react["default"].createElement(_Search["default"], {
    placeholder: "Search in menu",
    onSearch: onSearch,
    renderLeft: function renderLeft() {
      return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "search",
        size: "xs",
        w: "32px",
        color: "menuItem"
      });
    },
    withClearButton: true,
    component: Menu.MenuStyledInput,
    clearUnfocusOnEsc: true
  }) : /*#__PURE__*/_react["default"].createElement(Menu.Icon, {
    name: "Search",
    onClick: openMenu,
    color: "menuItem"
  }));
};
MenuSearch.propTypes = propTypes;
var _default = MenuSearch;
exports["default"] = _default;